import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IGymSettings} from "../../models/GymSettings";


interface IInitialGymSettingsState {
    gymSettings: IGymSettings | null;
    isGymSettingsLoading: boolean;
}

const initialGymSettingsState: IInitialGymSettingsState = {
    gymSettings: null,
    isGymSettingsLoading: true
}

export const gymSettingsSlice = createSlice({
    name: "gymSettings",
    initialState: initialGymSettingsState,
    reducers: {
        setGymSettings: (state, action: PayloadAction<IGymSettings>) => {
            state.isGymSettingsLoading = false;
            state.gymSettings = action.payload;
        }
    },
})

export const {setGymSettings} = gymSettingsSlice.actions;

export default gymSettingsSlice.reducer;